import { TextileHelper } from '../../../ts/helpers/TextileHelper';
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { DetailsTooltipStyles } from '../CardView/DetailsTooltipStyles';
import { SpacesSiteUrls } from '../SpacesSiteUrls';

export interface ContentTooltipProps {
  content: IContentInfo;
  urls: SpacesSiteUrls;
}

export const TooltipDescriptionTestId = 'tooltip-description-field';

export const ContentDescriptionClassNames = [
  'tb-textile',
  'tb-textile-preview-container',
  DetailsTooltipStyles.MetadataValueContentDescription
].join(' ');
